function removeClass (items, className) {
  if ( className === void 0 ) className = '';

  if (items) {
    items.forEach(function (item) {
      if (item.$el) {
        item.$el.classList.remove(className);
      } else {
        item.classList.remove(className);
      }
    });
  }
}

export default removeClass;
